import { ApiResponse } from "../interfaces/Api";
import { Bed, BedFormValue, OccupiedBed } from "../interfaces/BedInterface";
import { Get, Patch, Post, Delete } from "./apiHelper";

const bedsRoot = "/api/beds";

export const getBeds = async (props?: {
  roomIds?: Array<number>;
  active?: boolean;
}): Promise<ApiResponse<Array<Bed>>> => {
  const query = new URLSearchParams();
  if (props?.roomIds?.length) query.append("roomIds", props.roomIds.join(","));
  if (props?.active !== undefined) query.append("active", props.active.toString());

  const response = await Get(`${bedsRoot}?${query.toString()}`, true);
  return response.data as ApiResponse<Array<Bed>>;
};

export const postBeds = async (payload: BedFormValue): Promise<ApiResponse<Array<Bed>>> => {
  const response = await Post(bedsRoot, payload, true);
  return response.data as ApiResponse<Array<Bed>>;
};

export const patchBed = async (
  id: number,
  data: Partial<BedFormValue>
): Promise<ApiResponse<Bed>> => {
  console.log(data);
  const response = await Patch(`${bedsRoot}/${id}`, data, true);
  return response.data as ApiResponse<Bed>;
};

export const getTakenBedsInWard = async (wardId: number): Promise<ApiResponse<Array<number>>> => {
  const response = await Get(`${bedsRoot}/takenbeds/${wardId}`, true);
  return response.data as ApiResponse<Array<number>>;
};

export const deleteBed = async (id: number | string): Promise<ApiResponse<null>> => {
  const response = await Delete(`${bedsRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
};

export const getOccupiedBeds = async ({
  wardId,
  roomId
}: {
  roomId?: number;
  wardId?: number;
}): Promise<ApiResponse<Array<OccupiedBed>>> => {
  const query = new URLSearchParams();
  if (wardId) query.append("wardId", wardId.toString());
  if (roomId) query.append("roomId", roomId.toString());

  const response = await Get(`${bedsRoot}/occupied?${query.toString()}`, true);
  return response.data as ApiResponse<Array<OccupiedBed>>;
};
